import { render, staticRenderFns } from "./DailyWorks.vue?vue&type=template&id=40b1b320&scoped=true"
import script from "./DailyWorks.vue?vue&type=script&lang=js"
export * from "./DailyWorks.vue?vue&type=script&lang=js"
import style0 from "./DailyWorks.vue?vue&type=style&index=0&id=40b1b320&prod&scoped=true&lang=css"
import style1 from "./DailyWorks.vue?vue&type=style&index=1&id=40b1b320&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b1b320",
  null
  
)

export default component.exports